<template>
    <div class="ComparisonOfClassHistory">
        <div class="filtrate Compare">
            <el-select v-model="gradeId" placeholder="请选择" @change="gradeChange">
                <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-select class="filter_select" v-model="Filtervalue" multiple collapse-tags style="margin-left: 20px;"
                placeholder="请选择" @change="changeFiltervalue">
                <el-option v-for="item in Filterdata" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <div class="export flex-align"></div>
        </div>
        <div class="type_title flex-column-center">
            <h1>{{ gradeValue }}历次测评对比分析</h1>
        </div>
        <div class="overall_situation">
            <template v-if="!isEmpty">
                <div class="empty">
                    <el-empty description="暂无报告"></el-empty>
                </div>
            </template>
            <template v-else>
                <div class="BasicTemplate">
                    <div class="Secondary_heading">
                        <div class="vertical_grain_icon"></div> <span class="title">等级分布情况</span>
                    </div>
                    <div class="content" v-if="DimensionRating.length > 0">
                        <div class="DimensionRating_table_box">
                            <table class="DimensionRating_table">
                                <thead>
                                    <tr>
                                        <th>测评</th>
                                        <th>优秀</th>
                                        <th>良好</th>
                                        <th>合格</th>
                                        <th>待提升</th>
                                        <th>总计</th>
                                        <th>优良率</th>
                                        <th>合格率</th>
                                        <th>待提升</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- 循环渲染表单数据 -->
                                    <tr v-for="(item, index) in DimensionRating" :key="index">
                                        <td>
                                            {{
                                                item.name.includes('前测卷') ? '测评卷一' :
                                                item.name.includes('后测卷') ? '测评卷二' :
                                                    item.name
                                            }}
                                            {{
                                                (item.name.includes('前测卷') || item.name.includes('后测卷'))
                                                ? `（${dayjs(item.create_at).format('YYYY-MM-DD')}）`
                                                : ''
                                            }}
                                        </td>
                                        <td>{{ item.good_count }}</td>
                                        <td>{{ item.qualified_count }}</td>
                                        <td>{{ item.couhe }}</td>
                                        <td>{{ item.need_improvement_count }}</td>
                                        <td>{{ item.count }}</td>
                                        <td>{{ (item.good_ratio * 100).toFixed(2) }}%</td>
                                        <td>{{ (item.qualified_ratio * 100).toFixed(2) }}%</td>
                                        <td>{{ (item.need_improvement_ratio * 100).toFixed(2) }}%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="content flex-align-center Placeholder" v-else>
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                    <div class="ScoreChart_matrix" v-if="DimensionRating.length > 0">
                        <div class="Graphics" id="Graphic"></div>
                    </div>
                    <div class="Secondary_heading">
                        <div class="vertical_grain_icon"></div> <span class="title">班级历史成绩对比象限图</span>
                    </div>
                    <!-- {{ ClassifyData.length }} -->
                    <div class="content Graphics_matrix" v-if="ClassifyData.length > 0">
                        <div class="Graphics" v-for="(item, index) in ClassifyData" :key="index" @click="GoShowIt(item)">
                            <FourSymbolsLineDiagram_Single :id_type="index" :ownexamData="item" :GradeValue="classGrade"
                                v-if="item && item.length > 0">
                            </FourSymbolsLineDiagram_Single>
                        </div>
                    </div>
                    <div class="content Graphics_matrix flex-align-center Placeholder" v-else>
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                    <div class="Secondary_heading">
                        <div class="vertical_grain_icon"></div> <span class="title">班级学生分级点评</span>
                    </div>
                    <div class="content" v-if="!isAllFormDataEmpty">
                        <div class="ReviewForm">
                            <table class="DimensionRating_table">
                                <thead>
                                    <tr>
                                        <th class="ReviewForm_table_type">分类</th>
                                        <th>学生名单</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- 循环渲染表单数据 -->
                                    <tr v-for="(value, key) in nonEmptyFormData" :key="key">
                                        <td>{{ key }}</td>
                                        <td>
                                            <span class="List" v-for="(itemSon, indexSon) in value"
                                                @click="JumpToPersonalReport(itemSon.user_id, itemSon.name)">{{ itemSon.name
                                                }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="content flex-align-center Placeholder" v-else>
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                    <div class="content" v-if="!isAllFormDataEmpty">
                        <div class="SummaryAndSuggestions">总结与建议</div>
                        <p class="SummaryAndSuggestions_text">
                            本班学生整体呈现多元发展的态势，其中超过{{ positiveStudentPercentage
                            }}%的学生(双优型、稳定进步型、努力显著进步型)表现积极或持续进步，体现了班级良好的学习氛围;部分学生(天赋退步型、波动型、需关注型)需要更多关注和帮助，相信通过针对性指导，每个同学都能发挥出自己的潜力!
                        </p>
                        <div class="SuggestedCategory" v-if="syTypeNum > 0">· 双优型(第一象限稳定)({{ syTypeNum }}人)</div>
                        <p class="SummaryAndSuggestions_text" v-if="syTypeNum > 0">
                            {{ syTypeNum }}名学生表现出色且稳定，持续位于综合评价的第一象限。这些学生具备良好的学习习惯与扎实的基础能力，是班级学习的引领者。该类型学生常见问题与建议：
                            1、多横、多竖的间距偶尔有细微偏差，破坏了笔画排布的视觉均匀感，导致字的整体书写秩序感不够稳定；建议开展精细控笔训练，重点提升笔画书写质感与位置精细度，尤其强化多画等距不同间距精度；针对书写不足制定专项训练计划：若起收细节不到位导致间距精度偏差，则集中练习其收笔力度与位置控制；若多笔画交叉拥挤，重点练习交叉笔画间距分配。​
                            2、部分笔画过于拥挤或放得太开，对收放的把控不够精准，无法让笔画形成疏密的排布节奏，字体略显呆板。建议书写前认真观察笔画位置关系、呼应形态、长度比例及疏密层次，将书写规律深度内化，同时针对细节问题不断调整，让手部形成肌肉记忆、大脑养成书写规律意识，为未来快速书写夯实基础；通过持续优化，让大脑养成符合书写规律的疏密排布意识。
                        </p>
                        <div class="SuggestedCategory" v-if="wdjTypeNum > 0">· 稳健型({{ wdjTypeNum }}人)</div>
                        <p class="SummaryAndSuggestions_text" v-if="wdjTypeNum > 0">
                            {{ wdjTypeNum
                            }}名学生呈现出持续稳定的进步态势，两次测评间保持正向发展。这类学生的特点是：脚踏实地、循序渐进、抗挫折能力较强。他们通过自身的坚持与努力，正在逐步释放学习潜力，是班级中积极向上的中坚力量。该类型学生常见问题与建议：
                            1、部分字出现字的重心偏移的现象；建议加强对重心维度的理解，利用田字格的横中线和竖中线，建立字的中心轴，从而让字均衡平稳。
                            2、多画的间距，逐渐均匀但经细致还需要提升；建议加强控笔练习，提升笔画精细度，让笔画间距均匀稳定。
                            3、笔画位置关系相对准确，但偶尔会出现顾此失彼；建议写前认真观察，注意留心笔画位置关系，笔画间的呼应和主次的层次关系。
                            4、收放长短对比清晰，空间疏密的细节需要提升。建议书写前认真观察，字的疏密区域，根据书写规律布局笔画。
                        </p>
                        <div class="SuggestedCategory" v-if="nljTypeNum > 0">· 进取型({{ nljTypeNum }}人)</div>
                        <p class="SummaryAndSuggestions_text" v-if="nljTypeNum > 0">
                            这部分学生在努力维度表现突出，进步幅度显著，体现了"勤能补拙"的可贵品质。他们学习态度积极、意志坚定，需要关注的是帮助他们优化学习方法，提升学习效率。该类型学生常见问题与建议：
                            1、复合字穿插避让不够准确，各部之间宽窄长短比例略有偏差，以及间距忽大忽小，衔接不自然。建议书写前认真观察，并牢记部首书写规律，前期可以在田字格内，用铅笔轻轻画分部部件间的位置关系，书写时注意避让，遵循左部右侧笔画紧收让右，右部左侧笔画紧收让左；
                            2、占格居中不稳定，出现过大过小以及占格偏斜等问题。建议书写前认真观察字上下左右的笔画与格的间距，以及主笔和中心笔画。辅助定位，逐步调整字与格的关系，做到占位居中，大小一致。
                            3、多画等距不稳定，笔画需平行且间距视觉侧面均等。建议加强控笔练习，通过手腕手指的灵活练习，逐步提升笔画间距的一致性；
                            4、大部分字的重心都趋于稳定，但仍有个别字的重心出现失衡现象。建议在做到横平竖直的同时，可以通过田字格的横中心和竖中线，辅助建立字的中心轴，让复合字可以上下对正，且左右对称或均衡。
                        </p>
                        <div class="SuggestedCategory" v-if="tfxTypeNum > 0">· 天赋型({{ tfxTypeNum }}人)</div>
                        <p class="SummaryAndSuggestions_text" v-if="tfxTypeNum > 0">
                            {{ tfxTypeNum
                            }}名学生在书法学习上具备突出天赋与领悟力，在结构观察、重心把控、主笔理解等方面展现出明显优势，但在细节精度与复杂字形处理上仍需通过持续练习加以夯实。该类型学生常见问题与建议：
                            1、对角度变化类笔画的细节把握不足，影响撇、点等多画等距的精细表现，同一字内不同位置间距细节存在偏差；建议加强多角度笔画控笔训练，细化等距规律观察，针对性提升不同笔画组合的间距均匀度与细节表现力。
                            2、复合字内部组合关系理解不够深入，导致收放疏密层次表现不足；建议系统学习复合字组合规律，强化疏密对比意识，在书写中合理规划空间布局，提升整体节奏感。
                            3、复杂复合字的笔画位置与书写规律把握不够精准，易出现大小不当、占格不居中问题；建议深化观察方法训练，拆解复杂字形结构，精准定位笔画关系，确保无论简单或复杂字均能大小适中、居中规范。
                        </p>
                        <div class="SuggestedCategory" v-if="tftTypeNum > 0">· 潜能型({{ tftTypeNum }}人)</div>
                        <p class="SummaryAndSuggestions_text" v-if="tftTypeNum > 0">
                            {{ tftTypeNum
                            }}名学生在纵向维度出现暂时性波动，是充满潜力的学生，表现虽有波动，但这正说明有很大的提升空间！每次变化都是宝贵的经验，学会从波动中寻找规律，一起找到最适合的学习节奏！该类型学生常见问题与建议：
                            书写中会有些不稳定，如练 “居中” 时就顾不上 “重心”，练 “重心”
                            时笔画又写歪；换着练不同的字时，笔画角度（比如撇捺的倾斜度）、用力大小会变，不稳定；调整部首和部件的组合时，笔画位置总是找不着的问题，这是的几个建议：
                            1、字中心偏离田字格交点，占格过大；建议写每个字前，标记字的中心笔画和田字格交点，每天练12个字；写完后观察田字格边框与字四周笔画的位置关系，尽量让上下间距一致，左右距离均等，保证字在格子里不偏左也不偏右。
                            2、收放把控要么收得太紧，要么放得太开；建议寻找主笔和舒展的笔画，进行主次笔长短对比，以及字疏密布局的观察，默念书写规律后在下笔。
                            3、多画间距有些不一致，过大或多小；建议加强控笔练习，书写时注意笔画间距一致，且笔画之间保持平行，角度变化也会导致等距视觉的均衡感的缺失。
                            4、部件之间间距把握不太准确，穿插避让不到位。建议书写前先默念部首规律，划分部件之间的区域，遵循左部右侧紧收让右，右侧左部紧收让左，上部下方近齐让下，下方上部笔画缩短避让。并根据组合规律每天临写练习8个字，纠正偏差。
                        </p>
                        <div class="SuggestedCategory" v-if="bdTypeNum > 0">· 波动型({{ bdTypeNum }}人)</div>
                        <p class="SummaryAndSuggestions_text" v-if="bdTypeNum > 0">
                            {{ bdTypeNum
                            }}名学生的表现存在较大波动性，反映出状态不稳定、学习方法待优化等特点。这种波动既可能是挑战也是机遇，说明他们具有很强的可塑性。需要加强学习习惯培养和心理疏导，帮助其建立稳定的学习节奏。该类型学生常见问题与建议：
                            书写中会有些不稳定，如练 “居中” 时就顾不上 “重心”，练 “重心”
                            时笔画又写歪；换着练不同的字时，笔画角度（比如撇捺的倾斜度）、用力大小会变，不稳定；调整部首和部件的组合时，笔画位置总是找不着的问题，这是的几个建议：
                            1、首先要养成观察习惯，找准中心笔画和四周笔画，确定字与格子的位置关系，稳定居中占格；
                            2、要加强控笔练习，提升等距维度好的同时，养成书横平竖直的书写习惯，解决大部分重心问题；
                            3、还要熟记部首书写规律，在书写复合字时做到，相互避让，左让右，上让下。半包围留空小，全包围留空隙的组合习惯。当以上问题稳定后再逐一解决其它维度，让书写逐步稳定提升。
                        </p>
                        <div class="SuggestedCategory" v-if="xgzTypeNum > 0">· 重点型({{ xgzTypeNum }}人)</div>
                        <p class="SummaryAndSuggestions_text" v-if="xgzTypeNum > 0">
                            {{ xgzTypeNum
                            }}名学生目前在学习和成长方面面临较大挑战，需要教师和家长的特别关注。这些学生正处于发展的关键期，相信通过针对性帮助，他们一定能找到适合自己的成长路径。该类型学生常见问题与建议：
                            1、可以通过一些小技巧来让书写变得简单起来。例如可以在田字格内侧贴一圈细胶带（当“边界线”），书写时确保笔画不碰到胶带，每天练15个字；一起练习通关占格这个小挑战。
                            2、笔画微斜，有可能是姿势不正确呦！在练习控笔前，先调整正确的双姿，做到发力正确，练习手腕手指协调性，这时候书写中的横平竖直，和转折清晰就变得很简单了！
                            3、要是觉得写字没头绪，不知道如何收放，可以玩 “找主笔” 的小把戏！试着让主笔 “冒出头” 更显眼，笔画之间也像搭积木似的有顺序，每天练 20 个笔画，慢慢就会发现，写字越来越顺啦！
                        </p>
                    </div>

                </div>
            </template>
            <el-dialog :visible.sync="dialogVisible" width="60%" center @close="closedialog">
                <div class="Graphics_dialog">
                    <FourSymbolsLineDiagram_Single id_type="dialog" :ownexamData="BulletData" :GradeValue="classGrade"
                        v-if="BulletData.length > 0">
                    </FourSymbolsLineDiagram_Single>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import FourSymbolsLineDiagram_Single from '../report/FourSymbolsLineDiagram_Single.vue'
import {
    getGradeFromTermId,
    gradeKeyFromOwnexamTermId,
    lookupGradeK0,
    normalizeGradeKey,
} from '../report/quadrantGradeAxis.js'
import axios from 'axios';
export default {
    /**
     * 班级历次测评对比页：
     * 1) 先拉班级与试卷；2) 拉等级分布并渲染柱图；3) 用全量测评拉学生点位并做分型点评。
     * 分级点评仅在进页/换班用全量测评计算一次；测评筛选只影响等级分布与矩阵图。
     */
    components: {
        FourSymbolsLineDiagram_Single
    },
    props: {},
    data() {
        return {
            // 班级筛选
            gradeValue: null,
            gradeList: [],
            gradeId: null,
            className: null,
            // 页面状态
            isEmpty: false,
            formData: {},
            DimensionRating: [],
            // 分级点评专用：进页/换班一次性写入该班全部测评散点，不受筛选影响
            ownexam: [],
            Filtervalue: [],
            Filterdata: [],
            ClassifyData: [],
            dialogVisible: false,
            BulletData: [],
            syTypeNum: 0,
            wdjTypeNum: 0,
            nljTypeNum: 0,
            tfxTypeNum: 0,
            tftTypeNum: 0,
            bdTypeNum: 0,
            xgzTypeNum: 0,
            positiveStudentCount: 0, //双优型、稳健型、进取型总数
            positiveStudentPercentage: 0, //双优型、稳健型、进取型百分比
            matrixChartInstance: null,
            matrixChartResizeHandler: null,
            ratioFactorMap: {},
        };
    },
    computed: {
        nonEmptyFormData() {
            const result = {};
            for (const [key, value] of Object.entries(this.formData)) {
                if (value.length > 0) {
                    result[key] = value;
                }
            }
            return result;
        },
        // 分型结果是否全为空
        isAllFormDataEmpty() {
            return Object.values(this.formData).every(value => !value || value.length === 0);
        },
        classGrade() {
            const row = this.gradeList.find(item => Number(item.id) === Number(this.gradeId));
            if (!row) return 1;
            const termId = row.termId != null ? row.termId : row.term_id;
            return getGradeFromTermId(termId) || 1;
        },
        /** 系数用的年级：学期序号优先，否则从班级名里取「N年级」 */
        quadrantGradeKey() {
            const row = this.gradeList.find(item => Number(item.id) === Number(this.gradeId));
            const termId = row && (row.termId != null ? row.termId : row.term_id);
            const fromTerm = gradeKeyFromOwnexamTermId(termId);
            if (fromTerm != null) return fromTerm;
            return normalizeGradeKey(this.gradeValue || this.className || (row && row.name));
        },
    },
    methods: {
        async loadRatioFactorMap() {
            try {
                const factorRes = await this.$Api.Report.ratioFactorMap();
                this.ratioFactorMap = (factorRes && factorRes.data) || {};
            } catch (err) {
                console.error('年级系数 ratioFactorMap 失败', err);
                this.ratioFactorMap = {};
            }
        },
        /** 散点 x、y 乘当前班级年级系数 */
        scaleScatterList(list) {
            const k0 = lookupGradeK0(this.ratioFactorMap, this.quadrantGradeKey);
            return (Array.isArray(list) ? list : []).map((item) => {
                if (!item) return item;
                const x = Number(item.x);
                const y = Number(item.y);
                return {
                    ...item,
                    x: Number.isNaN(x) ? item.x : x * k0,
                    y: Number.isNaN(y) ? item.y : y * k0,
                };
            });
        },
        /** 分级用的区间、标准差与散点同一套系数。testdata 已在写入时乘过。 */
        scaleAbilityStats(students) {
            const k0 = lookupGradeK0(this.ratioFactorMap, this.quadrantGradeKey);
            if (k0 === 1) return students;
            const scale = (value) => {
                const n = Number(value);
                return Number.isFinite(n) ? n * k0 : value;
            };
            return students.map((student) => {
                if (!student) return student;
                return {
                    ...student,
                    range_x: scale(student.range_x),
                    range_y: scale(student.range_y),
                    std_deviation_x: scale(student.std_deviation_x),
                    std_deviation_y: scale(student.std_deviation_y),
                    average_x: scale(student.average_x),
                    average_y: scale(student.average_y),
                };
            });
        },
        // 获取班级并初始化默认班级的数据
        async gradequeryOrgInfo() {
            await this.loadRatioFactorMap();
            this.gradeValue = '';
            this.gradeId = '';
            this.gradeList = [];
            this.Filterdata = [];
            this.Filtervalue = [];
            let data = {
                schoolId: this.$route.query.schoolId,
            }
            let resData = await this.$Api.Upload.getClassBySchool(data);
            if (resData.data.length == 0) {
                this.isEmpty = false;
                return;
            }
            this.isEmpty = true;
            this.gradeList = resData.data;


            if (this.$route.query.source == 'upload') {
                this.className = this.$route.query.gradeValue || '';
                this.gradeValue = this.$route.query.gradeValue || '';
                this.gradeId = Number(this.$route.query.gradeId) || '';

                await this.getFilterexamination();//获取测评试卷类型
                await this.getvaluebyschool();//请求该学校下班级测评列表情况
                await this.getowntypebyclass(); //获取该班级参与过测评的学生

            } else {

                this.className = this.gradeList[0]?.name || '';
                this.gradeValue = this.gradeList[0]?.name || '';

                if (this.$route.query.classID) {
                    this.gradeId = Number(this.$route.query.classID);
                    const index = this.gradeList.findIndex(i => i.id == this.$route.query.classID);
                    this.gradeValue = this.gradeList[index].name;
                    this.className = this.gradeList[index].name;
                } else {
                    this.gradeId = this.gradeList[0]?.id || '';
                }
                await this.getFilterexamination();//获取测评试卷类型
                await this.getvaluebyschool();//请求该学校下班级测评列表情况
                await this.getowntypebyclass(); //获取该班级参与过测评的学生
            }
        },
        //切换班级
        async gradeChange(item) {
            this.Filterdata = [];
            this.Filtervalue = [];
            this.gradeId = item;
            const index = this.gradeList.findIndex(i => i.id == item);
            if (index === -1) return;
            this.gradeValue = this.gradeList[index].name;
            this.className = this.gradeList[index].name;
            //切换年级清空数据
            this.formData = {};
            this.syTypeNum = 0;
            this.wdjTypeNum = 0;
            this.nljTypeNum = 0;
            this.tfxTypeNum = 0;
            this.tftTypeNum = 0;
            this.bdTypeNum = 0;
            this.xgzTypeNum = 0;
            this.ownexam = [];
            this.ClassifyData = [];
            try {

                await this.getFilterexamination();//获取测评试卷类型
                await this.getvaluebyschool();//请求该学校下班级测评列表情况
                await this.getowntypebyclass(); //获取该班级参与过测评的学生

            } catch {
                console.error('异步调用失败:');
            }
        },
        //获取测评试卷类型；一次性拉全量测评散点供分级点评，矩阵默认展示前 4 场
        async getFilterexamination() {
            const classid = this.gradeId;
            const url = `https://spark.deploy.lezhireading.com/statistics/static/results/examination/${classid}`;

            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });

                this.Filterdata = response.data.data;
                // ownexam：分级点评专用（全量测评）；ClassifyData：矩阵展示（默认前 4 场）
                this.ownexam = [];
                this.ClassifyData = [];

                if (this.Filterdata.length > 0) {
                    this.Filtervalue = this.Filterdata.slice(0, 4).map(item => item.id);
                    const GroupingData = this.Filterdata.map(item => item.id);
                    for (const [index, testId] of GroupingData.entries()) {
                        try {
                            await this.getMatrixDiagram(testId, index, 'Initial');
                        } catch (error) {
                            console.error(`[顺序请求] 第 ${index + 1} 个请求失败，testId: ${testId}`, error);
                        }
                    }
                }
            } catch (error) {
                console.error('getFilterexamination 请求失败:', error);
            }
        },
        // 多选框 change：只刷新等级分布与矩阵图，不影响分级点评
        async changeFiltervalue() {
            this.ClassifyData = [];
            try {
                await this.getvaluebyschool();
                for (const [index, testId] of this.Filtervalue.entries()) {
                    try {
                        await this.getvaluebyschool();
                        await this.getMatrixDiagram(testId, index, 'Filter');
                    } catch (error) {
                        console.error(`[顺序请求] 请求失败，testId: ${testId}, 索引: ${index}`, error);
                    }
                }
            } catch (error) {
                console.error('changeFiltervalue 处理过程中出错:', error);
            }
        },
        initChart(data) {
            let that = this;
            this.$echarts.init(document.getElementById('Graphic')).dispose();
            let myChart = this.$echarts.init(document.getElementById("Graphic"));
            myChart.setOption({
                dataZoom: [
                    {
                        type: 'inside',
                        startValue: 0,
                        endValue: 100,
                    }
                ],
                legend: {
                    show: true,
                    bottom: '3%',
                    left: 'center',
                    formatter: function (name) {
                        const suffixMap = {
                            'good_ratio': '优良率',
                            'qualified_ratio': '合格率',
                            'need_improvement_ratio': '待提升',
                        };
                        return (suffixMap[name] || '');
                    },
                },
                grid: {
                    top: '19%',
                    left: '1%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true
                },
                dataset: {
                    dimensions: ['name', 'good_ratio', 'qualified_ratio', 'need_improvement_ratio'],
                    source: data
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        formatter: function (value) {
                            return value.includes('前测卷') ? '测评卷一' :
                                value.includes('后测卷') ? '测评卷二' :
                                    value;
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: function (value) {
                            return (value * 100).toFixed(2) + '%'; // 将值加上百分比符号
                        }
                    }
                },
                series: [
                    {
                        name: 'good_ratio',
                        type: 'bar',
                        encode: { y: 'good_ratio' },
                        barWidth: 30,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                            formatter: (params) => (Number(params.value[params.seriesName]) * 100).toFixed(2) + '%'
                        }
                    },
                    {
                        name: 'qualified_ratio',
                        type: 'bar',
                        barWidth: 30,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                        },
                        encode: { y: 'qualified_ratio' },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                            formatter: (params) => (Number(params.value[params.seriesName]) * 100).toFixed(2) + '%'
                        }
                    },
                    {
                        name: 'need_improvement_ratio',
                        type: 'bar',
                        barWidth: 30,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                        },
                        encode: { y: 'need_improvement_ratio' },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                            formatter: (params) => (Number(params.value[params.seriesName]) * 100).toFixed(2) + '%'
                        }
                    },
                ]
            });
            if (!this.matrixChartResizeHandler) {
                this.matrixChartResizeHandler = () => {
                    if (this.matrixChartInstance) {
                        this.matrixChartInstance.resize();
                    }
                };
                window.addEventListener('resize', this.matrixChartResizeHandler);
            }
        },



        // 获取历史测评散点：Initial 写入全量 ownexam（分级）+ 前 4 场矩阵；Filter 只更新矩阵
        async getMatrixDiagram(testId, index, type) {
            const classid = this.gradeId;
            const url = `https://spark.deploy.lezhireading.com/statistics/static/results/ownexambyclass/${classid}/${testId}`;

            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });
                const list = this.scaleScatterList(Array.isArray(response.data.data) ? response.data.data : []);
                if (type == 'Initial') {
                    // 分级点评：一次性带入该班全部测评
                    this.ownexam.push(...list);
                    if (index < 4) {
                        this.ClassifyData.push(list);
                    }
                }
                if (type == 'Filter') {
                    // 筛选仅刷新矩阵，不改动 ownexam / 分级名单
                    this.ClassifyData.push(list);
                }
                return response.data;
            } catch (error) {
                return null;
            }
        },

        // 获取该班级参与过测评的学生，并合并全量 testdata 后分型（仅进页/换班调用）
        async getowntypebyclass() {
            const classid = this.gradeId;
            const url = `https://spark.deploy.lezhireading.com/statistics/static/results/owntypebyclass/${classid}`;

            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });

                const PersonalAbilityRecord = response.data.data;

                if (!Array.isArray(PersonalAbilityRecord)) {
                    return;
                }
                if (!this.ownexam || !Array.isArray(this.ownexam)) {
                    this.ownexam = [];
                }
                const testMap = this.ownexam.reduce((acc, test) => {
                    if (!test || test.user_id == null) {
                        return acc;
                    }

                    const userId = test.user_id;
                    if (!acc[userId]) {
                        acc[userId] = [];
                    }
                    acc[userId].push(test);
                    return acc;
                }, {});
                const finalData = PersonalAbilityRecord.map(student => {
                    if (!student || student.user_id == null) {
                        return student;
                    }

                    return {
                        ...student,
                        testdata: testMap[student.user_id] || []
                    };
                });
                this.TypeGrouping(finalData);

            } catch (error) {
                console.error('❌ getowntypebyclass 请求失败:', error);
                this.TypeGrouping([]);
            }
        },
        // 班级学生分型：象限频率 + 统计指标
        TypeGrouping(data) {
            const list = this.scaleAbilityStats(Array.isArray(data) ? data : []);
            // const thresholdX = 69.3;
            // const thresholdY = 64.8;
            const thresholdX = 73.392;
            const thresholdY = 69.645;
            list.forEach(student => {
                let xiangxian1 = 0;
                let xiangxian2 = 0;
                let xiangxian3 = 0;
                let xiangxian4 = 0;
                let countall = 0;

                if (Array.isArray(student.testdata)) {
                    countall = student.testdata.length;
                    student.testdata.forEach(test => {
                        const x = test.x;
                        const y = test.y;

                        if (typeof x !== 'number' || typeof y !== 'number') return;

                        if (x >= thresholdX && y >= thresholdY) {
                            xiangxian1++;
                        }
                        else if (x < thresholdX && y >= thresholdY) {
                            xiangxian2++;
                        }
                        else if (x < thresholdX && y < thresholdY) {
                            xiangxian3++;
                        }
                        else if (x >= thresholdX && y < thresholdY) {
                            xiangxian4++;
                        }
                    });
                }

                student.xiangxian1 = xiangxian1;
                student.xiangxian2 = xiangxian2;
                student.xiangxian3 = xiangxian3;
                student.xiangxian4 = xiangxian4;
                student.countall = countall;
                student.reportType = [];
            });
            // 与 GradeAnalysisSch_Compare.vue 保持一致：按优先级匹配类型
            list.forEach(student => {
                if (
                    (student.xiangxian3 / student.countall >= 0.5) ||
                    (student.range_x < -5 && student.range_y < -5) ||
                    (student.range_y < -10 && student.xiangxian1 / student.countall < 0.6)
                ) {
                    student.reportType.push('重点型');
                    return;
                }
                if (student.std_deviation_x >= 8 || student.std_deviation_y >= 8) {
                    student.reportType.push('波动型');
                    return;
                }
                if ((student.xiangxian2 / student.countall >= 0.4) ||
                    (student.range_y > 5 && student.range_x <= 0)) {
                    student.reportType.push('天赋型');
                    return;
                }
                if (student.countall > 0 && student.xiangxian1 / student.countall >= 0.6 && student.range_x >= 2 && student.range_y >= 2) {
                    student.reportType.push('双优型');
                    return;
                }
                if ((student.range_x >= 6 && student.range_y <= 3) ||
                    (student.xiangxian4 / student.countall >= 0.4 && student.range_x > 0)) {
                    student.reportType.push('进取型');
                    return;
                }
                if (student.range_x > 0 && student.range_y > 0 && student.std_deviation_x < 8 && student.std_deviation_y < 8) {
                    student.reportType.push('稳健型');
                    return;
                }
                if (
                    (student.xiangxian1 / student.countall > 0.2 && student.xiangxian3 / student.countall > 0.1) ||
                    (student.range_y < 0 && student.range_x >= 0) ||
                    (student.range_x < 0 && student.range_y >= 0) ||
                    (student.range_x < 0 && student.range_y < 0 && student.xiangxian1 / student.countall > 0.3)
                ) {
                    student.reportType.push('潜能型');
                    return;
                }
                student.reportType.push('重点型');
            })
            const allTypes = ['双优型', '稳健型', '重点型', '进取型', '潜能型', '波动型', '天赋型'];
            const groupedByType = {};
            allTypes.forEach(type => groupedByType[type] = []);

            list.forEach(student => {
                if (Array.isArray(student.reportType)) {
                    student.reportType.forEach(type => {
                        if (allTypes.includes(type)) {
                            groupedByType[type].push(student);
                        }
                    });
                }
            });
            this.formData = groupedByType;
            this.syTypeNum = groupedByType['双优型'].length;
            this.wdjTypeNum = groupedByType['稳健型'].length;
            this.nljTypeNum = groupedByType['进取型'].length;
            this.tfxTypeNum = groupedByType['天赋型'].length;
            this.tftTypeNum = groupedByType['潜能型'].length;
            this.bdTypeNum = groupedByType['波动型'].length;
            this.xgzTypeNum = groupedByType['重点型'].length;
            const positiveTypes = ['双优型', '稳健型', '进取型'];
            const countedStudentIds = new Set();
            let positiveCount = 0;

            positiveTypes.forEach(type => {
                groupedByType[type].forEach(student => {
                    if (!countedStudentIds.has(student.id)) {
                        countedStudentIds.add(student.id);
                        positiveCount++;
                    }
                });
            });

            const totalCount = list.length;
            const positivePercentage = totalCount > 0
                ? ((positiveCount / totalCount) * 100).toFixed(2)
                : 0;

            this.positiveStudentCount = positiveCount;
            this.positiveStudentPercentage = positivePercentage; // 例如：83.33
        },
        // 请求班级等级分布并刷新柱图
        async getvaluebyschool() {
            const classid = this.gradeId
            const url = `https://spark.deploy.lezhireading.com/statistics/static/results/valuebyschool/${classid}`;

            const excludeKeys = new Set([
                'good_count',
                'qualified_count',
                'couhe',
                'need_improvement_count',
                'count'
            ]);
            try {
                const response = await axios.get(url, {
                    params: { noCache: Date.now() },
                    timeout: 50000,
                    headers: { 'Accept': 'application/json' }
                });
                if (response.data == null || response.data == '') {
                    this.DimensionRating = [];
                    this.initChart([]); // 避免图表崩溃
                    return;
                }
                let InitialData = response.data.data;
                // this.DimensionRating = response.data.data;
                const selectedResults = InitialData.filter(result =>
                    this.Filtervalue.includes(result.test_id)
                ).sort((a, b) => new Date(b.create_at) - new Date(a.create_at));
                this.DimensionRating = selectedResults;

                const filteredData = selectedResults.map(item => {
                    const filtered = {};
                    for (const [key, value] of Object.entries(item)) {
                        if (!excludeKeys.has(key)) {
                            filtered[key] = value;
                        }
                    }
                    return filtered;
                });
                this.$nextTick(() => {
                    this.initChart(filteredData);
                });
            } catch (error) {
                this.DimensionRating = [];
                this.initChart([]);
            }
        },
        // 点击矩阵图打开弹窗
        GoShowIt(data) {
            this.BulletData = data;
            this.dialogVisible = true;
        },
        // 关闭弹窗时清空数据
        closedialog() {
            this.BulletData = [];
        },
        //跳转个人报告
        JumpToPersonalReport(id, name) {
            const routeUrl = this.$router.resolve({
                path: '/PersonalExamPaper',
                query: {
                    userId: id,
                    user_name: name,
                }
            })
            window.open(routeUrl.href, '_blank')
        },
    },
    mounted() {
        this.gradequeryOrgInfo();
    },
    beforeDestroy() {
        if (this.matrixChartResizeHandler) {
            window.removeEventListener('resize', this.matrixChartResizeHandler);
            this.matrixChartResizeHandler = null;
        }
        if (this.matrixChartInstance) {
            try {
                this.matrixChartInstance.dispose();
            } catch (e) {
                /* ignore */
            }
            this.matrixChartInstance = null;
        }
    },
}
</script>
<style scoped lang="less">
.ComparisonOfClassHistory {
    padding-top: 120px;
    width: 100%;
    background-color: #f4f7f9;

    .First_level_heading {
        color: #01B58C;
        font-size: 22px;
        margin-bottom: 27px;
    }

    .Secondary_heading {
        display: flex;
        align-items: center;
        margin-top: 36px;

        .vertical_grain_icon {
            width: 4px;
            height: 18px;
            background: #01B68D;
            border-radius: 2px;
        }

        .title {
            font-size: 18px;
            color: #01B68D;
            margin-left: 10px;
        }
    }

    .filtrate {
        background: #FFFFFF;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: fixed;
        width: 100%;
        top: 60px;
        z-index: 999999;

        .el-select {
            margin-left: 21px;
        }

        /deep/ .el-select .el-input.is-focus .el-input__inner {
            border-color: #00B384;
        }

        /deep/ .el-select .el-input__inner:focus {
            border-color: #00B384;
        }

        /deep/ .el-select-dropdown__item.selected {
            color: #00B384 !important;
        }

        .export {
            background-color: #fff;
            box-sizing: border-box;
            padding-right: 202px;
            justify-content: flex-end;

            .wrap {
                cursor: pointer;
                margin-left: 21px;

                img {
                    width: 22px;
                    margin-right: 10px;
                }

                color: #999999;
                font-size: 15px;
            }
        }
    }

    .Compare {
        /deep/ .el-select-dropdown__item {
            padding-left: 20px !important;
            padding-right: 20px !important;
        }

        /deep/ .el-select__tags {
            max-width: none !important;
        }
    }

    .type_title {
        width: 1514px;
        margin: auto;
        margin-bottom: 20px;
        margin-top: 20px;

        h1 {
            color: #01B58C;
            font-size: 26px;
            font-weight: bold;
            margin-bottom: 15px;
        }

        h2 {
            color: #01B58C;
            font-size: 18px;
            font-weight: bold;
        }
    }

    .overall_situation {
        margin: auto;
        width: 1514px;
        margin-bottom: 20px;

        .BasicTemplate {
            background-color: #fff;
            border-radius: 15px;
            border: 1px solid transparent;
            margin-bottom: 17px;
            box-sizing: border-box;
            padding-bottom: 57px;
            flex-wrap: wrap;
            padding: 0 54px;
            padding-bottom: 100px;


            .content {
                margin-top: 36px;

                .SummaryAndSuggestions {
                    font-size: 18px;
                    color: #333;
                    font-weight: bold;
                    margin-bottom: 12px;
                }

                .SuggestedCategory {
                    font-size: 16px;
                    color: #333;
                    font-weight: bold;
                    margin-top: 12px;
                    margin-bottom: 12px;
                }

                .SummaryAndSuggestions_text {
                    font-size: 16px;
                    color: #666;
                    line-height: 28px;
                    text-indent: 2em;
                    margin-top: 12px;
                }
            }

            .Placeholder {
                min-height: 500px;
            }

            .Graphics_matrix {
                display: flex;
                flex-wrap: wrap;
                /* 允许换行 */
                gap: 20px;
                /* 元素之间的间距 */
                width: 100%;

                .Graphics {
                    flex: 0 0 calc(699px - 10px);
                    /* 每行两个，减去一半的 gap */
                    height: 500px;
                    border-radius: 8px;
                }
            }

            .ReviewForm {
                width: 100%;
                border-radius: 12px;

                .ReviewForm_table {
                    width: 100%;
                    border-collapse: collapse;
                    border-radius: 12px;

                }

                .ReviewForm_table th {
                    height: 45px;
                    border: 1px solid #ccc;
                    padding: 8px;
                    text-align: center;
                    background-color: #f2fbf9;
                    color: #01b58c;
                    font-weight: bold;
                    font-size: 16px;
                }

                .ReviewForm_table_type {
                    width: 300px;
                }

                .ReviewForm_table td {
                    height: 45px;
                    border: 1px solid #ccc;
                    padding: 8px;
                    font-size: 16px;

                    .List {
                        margin-right: 10px;
                    }
                }
            }

            .DimensionRating_table_box {
                border-radius: 12px;
            }

            .DimensionRating_table {
                border-collapse: collapse;
                border-spacing: 0;
                border-radius: 12px;
                width: 100%;
            }

            .DimensionRating_table th {
                height: 45px;
                border: 1px solid #e8e8e8;
                padding: 8px;
                text-align: center;
                background-color: #f2fbf9;
                color: #01b58c;
                font-weight: bold;
                font-size: 16px;
            }

            .DimensionRating_table td {
                height: 45px;
                border: 1px solid #e8e8e8;
                padding: 8px;
                font-size: 16px;
                text-align: center;

                .List {
                    margin-right: 10px;
                    cursor: pointer;
                    color: #0070d9;
                    text-decoration: underline;
                }
            }
        }


    }

    .ScoreChart_matrix {

        width: 100%;
        height: 500px;
        margin-top: 30px;
        margin-bottom: 100px;

        .Graphics {
            width: 100%;
            height: 100%;
        }
    }

    .Graphics_dialog {
        width: 100%;
        height: 700px;
    }

    /deep/.filter_select {
        width: 320px !important;

        .el-tag__close {
            display: none;
        }

        .el-select__tags>span {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .el-select__tags-text {
            max-width: 200px !important;
            width: auto !important;
        }
    }
}
</style>